import * as ambassadorWixRestaurantsMenusV1Item from './restaurants-menus-v1-item-items.http.js';
import * as ambassadorWixRestaurantsMenusV1ItemTypes from './restaurants-menus-v1-item-items.types.js';
import * as ambassadorWixRestaurantsMenusV1ItemUniversalTypes from './restaurants-menus-v1-item-items.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function duplicateItem(): __PublicMethodMetaInfo<
  'POST',
  { id: string },
  ambassadorWixRestaurantsMenusV1ItemUniversalTypes.DuplicateItemRequest,
  ambassadorWixRestaurantsMenusV1ItemTypes.DuplicateItemRequest,
  ambassadorWixRestaurantsMenusV1ItemUniversalTypes.DuplicateItemResponse,
  ambassadorWixRestaurantsMenusV1ItemTypes.DuplicateItemResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsMenusV1Item.duplicateItem(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/items/{id}/duplicate',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function createItem(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixRestaurantsMenusV1ItemUniversalTypes.CreateItemRequest,
  ambassadorWixRestaurantsMenusV1ItemTypes.CreateItemRequest,
  ambassadorWixRestaurantsMenusV1ItemUniversalTypes.CreateItemResponse,
  ambassadorWixRestaurantsMenusV1ItemTypes.CreateItemResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixRestaurantsMenusV1Item.createItem(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/items',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkCreateItems(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixRestaurantsMenusV1ItemUniversalTypes.BulkCreateItemsRequest,
  ambassadorWixRestaurantsMenusV1ItemTypes.BulkCreateItemsRequest,
  ambassadorWixRestaurantsMenusV1ItemUniversalTypes.BulkCreateItemsResponse,
  ambassadorWixRestaurantsMenusV1ItemTypes.BulkCreateItemsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixRestaurantsMenusV1Item.bulkCreateItems(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/items/create',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getItem(): __PublicMethodMetaInfo<
  'GET',
  { itemId: string },
  ambassadorWixRestaurantsMenusV1ItemUniversalTypes.GetItemRequest,
  ambassadorWixRestaurantsMenusV1ItemTypes.GetItemRequest,
  ambassadorWixRestaurantsMenusV1ItemUniversalTypes.GetItemResponse,
  ambassadorWixRestaurantsMenusV1ItemTypes.GetItemResponse
> {
  const payload = { itemId: ':itemId' } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsMenusV1Item.getItem(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/items/{itemId}',
    pathParams: { itemId: 'itemId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listItems(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixRestaurantsMenusV1ItemUniversalTypes.ListItemsRequest,
  ambassadorWixRestaurantsMenusV1ItemTypes.ListItemsRequest,
  ambassadorWixRestaurantsMenusV1ItemUniversalTypes.ListItemsResponse,
  ambassadorWixRestaurantsMenusV1ItemTypes.ListItemsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixRestaurantsMenusV1Item.listItems(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/items',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryItems(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixRestaurantsMenusV1ItemUniversalTypes.QueryItemsRequest,
  ambassadorWixRestaurantsMenusV1ItemTypes.QueryItemsRequest,
  ambassadorWixRestaurantsMenusV1ItemUniversalTypes.QueryItemsResponse,
  ambassadorWixRestaurantsMenusV1ItemTypes.QueryItemsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixRestaurantsMenusV1Item.queryItems(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/items/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function searchItems(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixRestaurantsMenusV1ItemUniversalTypes.SearchItemsRequest,
  ambassadorWixRestaurantsMenusV1ItemTypes.SearchItemsRequest,
  ambassadorWixRestaurantsMenusV1ItemUniversalTypes.SearchItemsResponse,
  ambassadorWixRestaurantsMenusV1ItemTypes.SearchItemsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixRestaurantsMenusV1Item.searchItems(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/items/search',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function countItems(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixRestaurantsMenusV1ItemUniversalTypes.CountItemsRequest,
  ambassadorWixRestaurantsMenusV1ItemTypes.CountItemsRequest,
  ambassadorWixRestaurantsMenusV1ItemUniversalTypes.CountItemsResponse,
  ambassadorWixRestaurantsMenusV1ItemTypes.CountItemsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixRestaurantsMenusV1Item.countItems(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/items/count',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateItem(): __PublicMethodMetaInfo<
  'PATCH',
  { itemId: string },
  ambassadorWixRestaurantsMenusV1ItemUniversalTypes.UpdateItemRequest,
  ambassadorWixRestaurantsMenusV1ItemTypes.UpdateItemRequest,
  ambassadorWixRestaurantsMenusV1ItemUniversalTypes.UpdateItemResponse,
  ambassadorWixRestaurantsMenusV1ItemTypes.UpdateItemResponse
> {
  const payload = { item: { id: ':itemId' } } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsMenusV1Item.updateItem(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/items/{item.id}',
    pathParams: { itemId: 'itemId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateItem(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixRestaurantsMenusV1ItemUniversalTypes.BulkUpdateItemRequest,
  ambassadorWixRestaurantsMenusV1ItemTypes.BulkUpdateItemRequest,
  ambassadorWixRestaurantsMenusV1ItemUniversalTypes.BulkUpdateItemResponse,
  ambassadorWixRestaurantsMenusV1ItemTypes.BulkUpdateItemResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixRestaurantsMenusV1Item.bulkUpdateItem(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/items/update',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteItem(): __PublicMethodMetaInfo<
  'DELETE',
  { itemId: string },
  ambassadorWixRestaurantsMenusV1ItemUniversalTypes.DeleteItemRequest,
  ambassadorWixRestaurantsMenusV1ItemTypes.DeleteItemRequest,
  ambassadorWixRestaurantsMenusV1ItemUniversalTypes.DeleteItemResponse,
  ambassadorWixRestaurantsMenusV1ItemTypes.DeleteItemResponse
> {
  const payload = { itemId: ':itemId' } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsMenusV1Item.deleteItem(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/items/{itemId}',
    pathParams: { itemId: 'itemId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkDeleteItems(): __PublicMethodMetaInfo<
  'DELETE',
  {},
  ambassadorWixRestaurantsMenusV1ItemUniversalTypes.BulkDeleteItemsRequest,
  ambassadorWixRestaurantsMenusV1ItemTypes.BulkDeleteItemsRequest,
  ambassadorWixRestaurantsMenusV1ItemUniversalTypes.BulkDeleteItemsResponse,
  ambassadorWixRestaurantsMenusV1ItemTypes.BulkDeleteItemsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixRestaurantsMenusV1Item.bulkDeleteItems(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/bulk/items/delete',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Item as ItemOriginal,
  ItemPricingOneOf as ItemPricingOneOfOriginal,
  PriceVariants as PriceVariantsOriginal,
  PriceVariant as PriceVariantOriginal,
  PriceInfo as PriceInfoOriginal,
  Image as ImageOriginal,
  Label as LabelOriginal,
  OrderSettings as OrderSettingsOriginal,
  FulfillmentMethodType as FulfillmentMethodTypeOriginal,
  FulfillmentMethodTypeWithLiterals as FulfillmentMethodTypeWithLiteralsOriginal,
  Availability as AvailabilityOriginal,
  AvailabilityAvailabilityTypeOptionsOneOf as AvailabilityAvailabilityTypeOptionsOneOfOriginal,
  AvailabilityType as AvailabilityTypeOriginal,
  AvailabilityTypeWithLiterals as AvailabilityTypeWithLiteralsOriginal,
  WeeklyScheduleOptions as WeeklyScheduleOptionsOriginal,
  DayOfWeekAvailability as DayOfWeekAvailabilityOriginal,
  EntitiesDayOfWeek as EntitiesDayOfWeekOriginal,
  EntitiesDayOfWeekWithLiterals as EntitiesDayOfWeekWithLiteralsOriginal,
  TimeOfDayRange as TimeOfDayRangeOriginal,
  TimeOfDay as TimeOfDayOriginal,
  TimestampRangesOptions as TimestampRangesOptionsOriginal,
  AvailableRange as AvailableRangeOriginal,
  ModifierGroup as ModifierGroupOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  ExternalReferenceInfo as ExternalReferenceInfoOriginal,
  DuplicateItemRequest as DuplicateItemRequestOriginal,
  DuplicateItemResponse as DuplicateItemResponseOriginal,
  UpdateDocumentsEvent as UpdateDocumentsEventOriginal,
  UpdateDocumentsEventOperationOneOf as UpdateDocumentsEventOperationOneOfOriginal,
  DocumentUpdateOperation as DocumentUpdateOperationOriginal,
  IndexDocument as IndexDocumentOriginal,
  DocumentPayload as DocumentPayloadOriginal,
  DocumentImage as DocumentImageOriginal,
  Enum as EnumOriginal,
  EnumWithLiterals as EnumWithLiteralsOriginal,
  DeleteByIdsOperation as DeleteByIdsOperationOriginal,
  DeleteByFilterOperation as DeleteByFilterOperationOriginal,
  UpdateByFilterOperation as UpdateByFilterOperationOriginal,
  UpdateExistingOperation as UpdateExistingOperationOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  Empty as EmptyOriginal,
  SearchIndexingNotification as SearchIndexingNotificationOriginal,
  State as StateOriginal,
  StateWithLiterals as StateWithLiteralsOriginal,
  SitePropertiesNotification as SitePropertiesNotificationOriginal,
  SitePropertiesEvent as SitePropertiesEventOriginal,
  Properties as PropertiesOriginal,
  Categories as CategoriesOriginal,
  Locale as LocaleOriginal,
  Address as AddressOriginal,
  AddressHint as AddressHintOriginal,
  PlacementType as PlacementTypeOriginal,
  PlacementTypeWithLiterals as PlacementTypeWithLiteralsOriginal,
  GeoCoordinates as GeoCoordinatesOriginal,
  BusinessSchedule as BusinessScheduleOriginal,
  TimePeriod as TimePeriodOriginal,
  DayOfWeek as DayOfWeekOriginal,
  DayOfWeekWithLiterals as DayOfWeekWithLiteralsOriginal,
  SpecialHourPeriod as SpecialHourPeriodOriginal,
  Multilingual as MultilingualOriginal,
  SupportedLanguage as SupportedLanguageOriginal,
  ResolutionMethod as ResolutionMethodOriginal,
  ResolutionMethodWithLiterals as ResolutionMethodWithLiteralsOriginal,
  ConsentPolicy as ConsentPolicyOriginal,
  Translation as TranslationOriginal,
  ChangeContext as ChangeContextOriginal,
  ChangeContextPayloadOneOf as ChangeContextPayloadOneOfOriginal,
  PropertiesChange as PropertiesChangeOriginal,
  SiteCreated as SiteCreatedOriginal,
  SiteCloned as SiteClonedOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  InvalidateCache as InvalidateCacheOriginal,
  InvalidateCacheGetByOneOf as InvalidateCacheGetByOneOfOriginal,
  App as AppOriginal,
  Page as PageOriginal,
  URI as URIOriginal,
  File as FileOriginal,
  CustomTag as CustomTagOriginal,
  Pages as PagesOriginal,
  URIs as URIsOriginal,
  DeleteLocationIdsFromVariants as DeleteLocationIdsFromVariantsOriginal,
  DeleteLocationIdsFromModifierGroups as DeleteLocationIdsFromModifierGroupsOriginal,
  CreateItemRequest as CreateItemRequestOriginal,
  CreateItemResponse as CreateItemResponseOriginal,
  BulkCreateItemsRequest as BulkCreateItemsRequestOriginal,
  BulkCreateItemsResponse as BulkCreateItemsResponseOriginal,
  BulkCreateItemResult as BulkCreateItemResultOriginal,
  ItemMetadata as ItemMetadataOriginal,
  ApplicationError as ApplicationErrorOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  GetItemRequest as GetItemRequestOriginal,
  GetItemResponse as GetItemResponseOriginal,
  ListItemsRequest as ListItemsRequestOriginal,
  CursorPaging as CursorPagingOriginal,
  ListItemsResponse as ListItemsResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  QueryItemsRequest as QueryItemsRequestOriginal,
  CursorQuery as CursorQueryOriginal,
  CursorQueryPagingMethodOneOf as CursorQueryPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  QueryItemsResponse as QueryItemsResponseOriginal,
  SearchItemsRequest as SearchItemsRequestOriginal,
  CursorSearch as CursorSearchOriginal,
  CursorSearchPagingMethodOneOf as CursorSearchPagingMethodOneOfOriginal,
  Aggregation as AggregationOriginal,
  AggregationKindOneOf as AggregationKindOneOfOriginal,
  RangeBucket as RangeBucketOriginal,
  SortType as SortTypeOriginal,
  SortTypeWithLiterals as SortTypeWithLiteralsOriginal,
  SortDirection as SortDirectionOriginal,
  SortDirectionWithLiterals as SortDirectionWithLiteralsOriginal,
  ScalarType as ScalarTypeOriginal,
  ScalarTypeWithLiterals as ScalarTypeWithLiteralsOriginal,
  AggregationType as AggregationTypeOriginal,
  AggregationTypeWithLiterals as AggregationTypeWithLiteralsOriginal,
  ValueAggregation as ValueAggregationOriginal,
  RangeAggregation as RangeAggregationOriginal,
  ScalarAggregation as ScalarAggregationOriginal,
  SearchDetails as SearchDetailsOriginal,
  Mode as ModeOriginal,
  ModeWithLiterals as ModeWithLiteralsOriginal,
  SearchItemsResponse as SearchItemsResponseOriginal,
  AggregationData as AggregationDataOriginal,
  ValueAggregationResult as ValueAggregationResultOriginal,
  RangeAggregationResult as RangeAggregationResultOriginal,
  ValueResults as ValueResultsOriginal,
  RangeResults as RangeResultsOriginal,
  ScalarResult as ScalarResultOriginal,
  AggregationResults as AggregationResultsOriginal,
  AggregationResultsResultOneOf as AggregationResultsResultOneOfOriginal,
  CountItemsRequest as CountItemsRequestOriginal,
  CountItemsResponse as CountItemsResponseOriginal,
  UpdateItemRequest as UpdateItemRequestOriginal,
  UpdateItemResponse as UpdateItemResponseOriginal,
  BulkUpdateItemRequest as BulkUpdateItemRequestOriginal,
  MaskedItem as MaskedItemOriginal,
  BulkUpdateItemResponse as BulkUpdateItemResponseOriginal,
  BulkUpdateItemResponseBulkItemResult as BulkUpdateItemResponseBulkItemResultOriginal,
  DeleteItemRequest as DeleteItemRequestOriginal,
  DeleteItemResponse as DeleteItemResponseOriginal,
  BulkDeleteItemsRequest as BulkDeleteItemsRequestOriginal,
  BulkDeleteItemsResponse as BulkDeleteItemsResponseOriginal,
  BulkDeleteItemResult as BulkDeleteItemResultOriginal,
  CloneItemsRequest as CloneItemsRequestOriginal,
  CloneItemsResponse as CloneItemsResponseOriginal,
  BulkUpdateBusinessLocationIdsRequest as BulkUpdateBusinessLocationIdsRequestOriginal,
  BulkUpdateBusinessLocationIdsResponse as BulkUpdateBusinessLocationIdsResponseOriginal,
  BulkUpdateBusinessLocationIdsResponseBulkItemResult as BulkUpdateBusinessLocationIdsResponseBulkItemResultOriginal,
  BulkUpdateBusinessLocationIdsPerEntityRequest as BulkUpdateBusinessLocationIdsPerEntityRequestOriginal,
  ItemIdLocationIds as ItemIdLocationIdsOriginal,
  BulkUpdateBusinessLocationIdsPerEntityResponse as BulkUpdateBusinessLocationIdsPerEntityResponseOriginal,
  BulkItemResult as BulkItemResultOriginal,
  SyncContentToMultilingualRequest as SyncContentToMultilingualRequestOriginal,
  SyncContentToMultilingualResponse as SyncContentToMultilingualResponseOriginal,
  CountItemsApplicationErrors as CountItemsApplicationErrorsOriginal,
} from './restaurants-menus-v1-item-items.types.js';
